import { render, staticRenderFns } from "./ServerNotifications.vue?vue&type=template&id=95c8a9c6&"
import script from "./ServerNotifications.vue?vue&type=script&lang=js&"
export * from "./ServerNotifications.vue?vue&type=script&lang=js&"
import style0 from "./ServerNotifications.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95c8a9c6')) {
      api.createRecord('95c8a9c6', component.options)
    } else {
      api.reload('95c8a9c6', component.options)
    }
    module.hot.accept("./ServerNotifications.vue?vue&type=template&id=95c8a9c6&", function () {
      api.rerender('95c8a9c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "auth_ui/static/vue-src/components/ServerNotifications.vue"
export default component.exports